import { render, staticRenderFns } from "./shoucang.vue?vue&type=template&id=59323edc&scoped=true&"
import script from "./shoucang.vue?vue&type=script&lang=js&"
export * from "./shoucang.vue?vue&type=script&lang=js&"
import style0 from "./shoucang.vue?vue&type=style&index=0&id=59323edc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59323edc",
  null
  
)

export default component.exports